import { render, staticRenderFns } from "./CouponUserList.vue?vue&type=template&id=1fec35ca&"
import script from "./CouponUserList.vue?vue&type=script&lang=js&"
export * from "./CouponUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports